import React from 'react';
import { Form } from 'reactstrap';
import { InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import { FormDataGatewayPaymentInputName } from '../../types';

interface FilterContentProps {
  formData: FormData;
  formErrors: FormErrors;
  onChangeFormInput: OnChangeFormInput;
}

export const FilterContent: React.FC<FilterContentProps> = ({
  formData,
  formErrors,
  onChangeFormInput,
}) => (
  <div className="filter-modal-content">
    <Form noValidate={true} onSubmit={(e): void => e.preventDefault()}>
      <InputText
        name="startDate"
        label="Data início"
        placeholder="EX: 01/01/2026 00:00"
        maxLength={16}
        value={formData[FormDataGatewayPaymentInputName.startDate]}
        onChange={e => onChangeFormInput(FormDataGatewayPaymentInputName.startDate)(e.target.value)}
        error={formErrors.startDate && formErrors.startDate[0]}
      />
      <InputText
        name="endDate"
        label="Data Fim"
        placeholder="EX: 31/12/2026 00:00"
        maxLength={16}
        value={formData[FormDataGatewayPaymentInputName.endDate]}
        onChange={e => onChangeFormInput(FormDataGatewayPaymentInputName.endDate)(e.target.value)}
        error={formErrors.endDate && formErrors.endDate[0]}
      />
    </Form>
  </div>
);
